import { Link } from 'react-router-dom';
import ScrollReveal from '@/components/ScrollReveal';
import ServiceCard from '@/components/ServiceCard';
import { SERVICES } from '@/lib/pricing';

export default function ServicesOverview() {
  return (
    <section className="py-16 md:py-32 bg-secondary/30">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-16">
        <ScrollReveal>
          <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-16">
            <div>
              <p className="caps-label text-orange mb-4">Our Services</p>
              <h2 className="font-display font-extrabold text-navy" style={{ fontSize: 'clamp(2rem, 4vw, 3rem)' }}>
                Everything your property needs
              </h2>
            </div>
            <Link to="/services" className="text-sm font-semibold text-orange hover:text-orange-dark mt-4 lg:mt-0">
              View all services →
            </Link>
          </div>
        </ScrollReveal>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((service, i) => (
            <ScrollReveal key={service.id} delay={i * 0.05}>
              <ServiceCard service={service} />
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}